// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"tX-z","sponsoredTooltipWrapper":"uX-z","sponsoredTooltip":"vX-z","newCard":"wX-z"};